import PropTypes from "prop-types";
import Avatar from "@shared/v2/Avatar";
import Tooltip from "@shared/v2/Tooltip";
import { truncateTime } from "./reportHelpers";
import { TD, TR } from "./BusinessDashboard/Table/Table";

const AgentCallsRow = ({ agent }) => (
  <TR>
    <TD>
      <a className="tw-flex tw-items-center tw-gap-[8px]" href={`/people/${agent.user_path}`}>
        <Avatar size="medium" src={agent.avatar} alt={agent.agent} />
        {agent.agent}
      </a>
    </TD>

    <TD>{agent.call_report_agent_total_lead_count}</TD>
    <TD>{agent.call_report_lead_call_count}</TD>
    <TD>{agent.call_report_manual_calls}</TD>
    <TD>{agent.call_report_dialer_calls}</TD>
    <TD>{agent.call_report_total_calls}</TD>
    <TD>
      {agent.call_report_total_dialer_call_time !== "0 seconds" ? (
        <Tooltip
          placement="top"
          trigger={truncateTime(agent.call_report_total_dialer_call_time)}
          content={agent.call_report_total_dialer_call_time}
        />
      ) : (
        truncateTime(agent.call_report_total_dialer_call_time)
      )}
    </TD>
  </TR>
);

AgentCallsRow.propTypes = {
  agent: PropTypes.shape().isRequired,
};

export default AgentCallsRow;
